var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramRepayments40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,20 C9.5,26.0751322 14.4248678,31 20.5,31 C23.5375661,31 26.2875661,29.7687831 28.2781746,27.7781746 M31.5,20 C31.5,13.9248678 26.5751322,9 20.5,9 C17.4624339,9 14.7124339,10.2312169 12.7218254,12.2218254",
    id: "Shape",
    stroke: "#4F4C4D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "End",
    stroke: "#4F4C4D",
    fill: "#FFCC00",
    transform: "translate(31.500000, 19.625000) scale(1, -1) rotate(-90.000000) translate(-31.500000, -19.625000) ",
    points: "33.375 19.625 29.625 22.125 29.625 17.125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "End",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    transform: "translate(9.500000, 19.375000) rotate(-90.000000) translate(-9.500000, -19.375000) ",
    points: "11.375 19.375 7.625 21.875 7.625 16.875"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(11.500000, 11.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Shape",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "$",
    transform: "translate(6.750000, 3.000000)",
    stroke: "#4F4D4C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.75 L3.00156516,9.75 M2.625,6 L1.875,6 M1.49843484,2.25 L4.5,2.25",
    id: "Arms"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875,2.25 C0.839466094,2.25 0,3.08946609 0,4.125 C0,5.16053391 0.839466094,6 1.875,6 L1.875,6",
    id: "Curve"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,6 C3.46446609,6 2.625,6.83946609 2.625,7.875 C2.625,8.91053391 3.46446609,9.75 4.5,9.75",
    id: "Curve-bottom",
    transform: "translate(3.562500, 7.875000) scale(-1, 1) translate(-3.562500, -7.875000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.25,
    y1: 2.25,
    x2: 2.25,
    y2: 0,
    id: "Stick-top"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.25,
    y1: 12,
    x2: 2.25,
    y2: 9.75,
    id: "Stick-bottom"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramRepayments40);
export default __webpack_public_path__ + "static/media/pictogramRepayments40.ded40042fd6b0fbb65a2b274258d7d4f.svg";
export { ForwardRef as ReactComponent };